/**
 * Seeded PRNG (plan §"Cross-cutting conventions": all randomness flows through
 * this — same seed, same playback).
 */
/** mulberry32: tiny, fast, good-enough distribution for VFX. Returns floats in [0, 1). */
export function mulberry32(seed) {
    let a = seed >>> 0;
    return () => {
        a = (a + 0x6d2b79f5) | 0;
        let t = Math.imul(a ^ (a >>> 15), 1 | a);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}
/** Derive a child seed from a parent seed + stream index (instance seed → per-layer streams). */
export function deriveSeed(seed, stream) {
    let h = (seed ^ 0x9e3779b9) >>> 0;
    h = Math.imul(h ^ (stream + 0x85ebca6b), 0xc2b2ae35) >>> 0;
    h ^= h >>> 16;
    h = Math.imul(h, 0x45d9f3b) >>> 0;
    h ^= h >>> 16;
    return h >>> 0;
}
export function randRange(rng, a, b) {
    return a + (b - a) * rng();
}
